import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { YimTalkBrandTitle } from '@/components/yim-talk/YimTalkBrandTitle';
import logoImage from '@/assets/images/logo.webp';

export function YimTalkTopBar() {
  const { t } = useTranslation();

  return (
    <header className="flex shrink-0 items-center gap-2 px-4 py-3">
      <Link
        to="/yim-talk"
        aria-label={t('yimTalk.heroTitle')}
        className="mr-auto flex min-w-0 items-center gap-2 rounded-lg focus-visible:ring-2 focus-visible:ring-accent-400"
      >
        <img
          src={logoImage}
          alt=""
          width={36}
          height={36}
          loading="eager"
          decoding="async"
          className="h-9 w-9 shrink-0 rounded-lg object-contain drop-shadow-sm"
        />
        <YimTalkBrandTitle className="truncate text-lg font-black tracking-tight text-white" />
      </Link>
      <LanguageSwitcher variant="yimTalkPill" />
      <Link
        to="/get-involved"
        className="shrink-0 rounded-full border border-white/30 bg-white/10 px-2.5 py-1.5 text-[11px] font-bold text-white hover:bg-white/20 focus-visible:ring-2 focus-visible:ring-accent-400 sm:px-3 sm:text-xs"
      >
        {t('yimTalk.joinUs')}
      </Link>
    </header>
  );
}
